type ScoreCategory = 'bad' | 'warning' | 'good';

export const categorizeScore = (score: number): ScoreCategory => {
  if (score <= 2) {
    return 'bad';
  }
  if (score <= 4) {
    return 'warning';
  }
  return 'good';
};
